import React from 'react';
import API from '../../servicios/api';
// import EMPLEADOS_FOTOS from '../../servicios/empleadosFotos';

import UploadImage from '../UploadDisplaySaveImage';
import tipoDocs from '../../data/tipodoc.json';
import tipoGeneros from '../../data/generos.json';
import tipoVinculacion from '../../data/tipovinculacion.json';
import tipoAreas from '../../data/tipoareas.json';
import tipoCargos from '../../data/tipocargos.json';
import rangoSalarial from '../../data/rangosalarial.json';

class Perfil extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            // PERFIL
            // id: "", //int
            uId: null,
            docId2photo:"",
            docId:"",
            tipodoc:"C.C.",
            genero:"M",
            tiposangre:"",
            nombres:"",
            apellidos:"",
            alias:"",
            fechanacimiento:"",
            lugarnacimiento:"",
            estadocivil:"",
            educacion:"",
            nivelescolaridad:"",
            estudiaactualmente:"0",
            carrera:"",
            institucion:"",
            jornada:"",
            email:"",
            celular:"",
            jefehogar:"",
            personasacargo:"",
            numhijos:"",
            fechaingreso:"",
            tipovinculacion:"Seleccionar...",
            area:"Seleccionar...",
            cargo:"Seleccionar...",
            rangosalarial:"Seleccionar...",
            otraocupacion:"",
            tienefmliaclub:"No",
            fmliaclub:"",
            activo:"1",
            estado:"PENDIENTE",
            programaprincipal:"",
            categoriaseguimiento:"",
            acuerdocorresp:"0",
            foto:"",
            claveAPI:"",
            passwd:"",
            comentarios:"",
            actualizacion:"",
            version:"",
            modificadopor:"",  
            errores: [],
            serverror:""
         };
    }

    componentDidMount(){
        const docid = this.props.match.params.docid;
        if (docid && docid!=="" && docid!==undefined) {
            this.setState({docId:docid, docId2photo:docid});
        }
        if (docid==="" || docid===undefined){
            const _id = new Date(Date.now()).toLocaleString().replaceAll('/','').replaceAll(':','').replaceAll('AM','').replace(',','').replaceAll(' ','');
            this.setState({
                // foto:"beneficiario_tmp_"+_id+".jpg",
                docId2photo:_id
            });
        }
    }

    cambioValor = (e) =>{
        const state = this.state;
        state[e.target.name] = e.target.value;
        if (e.target.name==="docId" && e.target.value===""){
            state.docId2photo = ""; //e.target.value;
        } 
        state["edad"] = (state.edad) ? state.edad : 0;
        if (e.target.name==="fechanacimiento"){
            const edad = this.calcularEdad(e.target.value);
            state.edad = edad;
        }
        state["antiguedad"] = (state.antiguedad) ? state.antiguedad : 0;
        if (e.target.name==="fechaingreso"){
            const antiguedad = this.calcularEdad(e.target.value);
            state.antiguedad = antiguedad;
        }
        this.setState( { state, errores:[], serverror:""});
    }

    calcularEdad = (f) =>{
        // console.log(f);
        const fn = f.split('-');
        const birth_year = fn[0];
        const birth_month = fn[1];
        const birth_day = fn[2];
        const today_date = new Date();
        const today_year = today_date.getFullYear();
        const today_month = today_date.getMonth();
        const today_day = today_date.getDate();
        let age = today_year - birth_year;
        
        if (today_month < (birth_month - 1)) {
            age--;
        }
        if (((birth_month - 1) === today_month) && (today_day < birth_day)) {
            age--;
        }
        return age;
    }

    verificarError(elm){
        return this.state.errores.indexOf(elm) !== -1;
    }

    enviarDatos = (e) => {
        e.preventDefault();
        let { //uId, 
            docId2photo,
            docId, tipodoc, genero, tiposangre, nombres, apellidos, 
            alias, fechanacimiento, edad, antiguedad,
            lugarnacimiento, estadocivil, educacion, nivelescolaridad, 
            estudiaactualmente, carrera, institucion, jornada, 
            email, celular, jefehogar,
            personasacargo, numhijos, fechaingreso, tipovinculacion,
            area, cargo, rangosalarial, otraocupacion, tienefmliaclub, fmliaclub,
            activo, estado, 
            programaprincipal, categoriaseguimiento, acuerdocorresp,
            foto
            // foto, claveAPI, passwd,  comentarios, 
            // actualizacion, version, modificadopor
        } = this.state;

        // Validar Errores
        let errores = [];
        if (!docId) errores.push('error_docId');
        if (!tipodoc) errores.push('error_tipodoc');
        if (!genero) errores.push('error_genero');
        // if (!tiposangre) errores.push('error_tiposangre');
        if (!nombres) errores.push('error_nombres');
        if (!apellidos) errores.push('error_apellidos');
        // if (!alias) errores.push('error_alias');
        if (!fechanacimiento) errores.push('error_fechanacimiento');
        // if (!lugarnacimiento) errores.push('error_lugarnacimiento');
        // if (!estadocivil) errores.push('error_estadocivil');
        // if (!educacion) errores.push('error_educacion');
        // if (!nivelescolaridad) errores.push('error_nivelescolaridad');
        // if (!estudiaactualmente) errores.push('error_estudiaactualmente');
        // if (!carrera) errores.push('error_carrera');
        // if (!institucion) errores.push('error_institucion');
        // if (!jornada) errores.push('error_jornada');
        if (!email) errores.push('error_email');
        if (!celular) errores.push('error_celular');
        // if (!jefehogar) errores.push('error_jefehogar');
        // if (!personasacargo) errores.push('error_personasacargo');
        // if (!numhijos) errores.push('error_numhijos');
        if (!fechaingreso) errores.push('error_fechaingreso');
        if (!cargo) errores.push('error_cargo');
        if (!rangosalarial) errores.push('error_rangosalarial');
        if (!tienefmliaclub) errores.push('error_tienefmliaclub');
        if (!activo) errores.push('error_activo');
        if (!estado) errores.push('error_estado');
        // if (!foto) errores.push('error_foto');
        // if (!claveAPI) errores.push('error_claveAPI');
        // if (!passwd) errores.push('error_passwd');
        // if (!modificadopor) errores.push('error_modificadopor'); 

        if(tipovinculacion==="Seleccionar...") errores.push('error_tipovinculacion');
        if(area==="Seleccionar...") errores.push('error_area');
        if(cargo==="Seleccionar...") errores.push('error_cargo');
        if(rangosalarial==="Seleccionar...") errores.push('error_rangosalarial');

        this.setState({errores:errores});
        if (errores.length>0) {
            console.log(errores);
            return false;
        }

        // Si ok
        if (tienefmliaclub.toLocaleLowerCase()==="si" || tienefmliaclub.toLocaleLowerCase()==="1"){
            tienefmliaclub = 1;
        } else {
            tienefmliaclub = 0;
        }
        
        if (foto==="" && (docId2photo!=="" || docId2photo!==undefined)){
            // const _id = new Date(Date.now()).toLocaleString().replaceAll('/','').replaceAll(':','').replaceAll('AM','').replace(',','').replaceAll(' ','');
            foto = "beneficiario_"+docId2photo+".jpg";
        }

        var datosaEnviar = {
            docId:docId, tipodoc:tipodoc, genero:genero, tiposangre:tiposangre, 
            nombres:nombres, apellidos:apellidos, alias:alias, 
            fechanacimiento:fechanacimiento, edad:edad, antiguedad:antiguedad,
            lugarnacimiento:lugarnacimiento, 
            estadocivil:estadocivil, educacion:educacion, nivelescolaridad:nivelescolaridad, 
            estudiaactualmente:estudiaactualmente, carrera:carrera, institucion:institucion, 
            jornada:jornada, email:email, celular:celular, jefehogar:jefehogar,
            personasacargo:personasacargo, numhijos:numhijos, fechaingreso:fechaingreso, 
            tipovinculacion:tipovinculacion, area:area, cargo:cargo, rangosalarial:rangosalarial, otraocupacion:otraocupacion, 
            tienefmliaclub:tienefmliaclub, fmliaclub:fmliaclub, activo:activo, estado:estado, 
            programaprincipal:programaprincipal, categoriaseguimiento:categoriaseguimiento, 
            acuerdocorresp:acuerdocorresp,
            foto:foto, 
            // claveAPI:claveAPI, passwd:passwd, comentarios:comentarios, 
            // actualizacion:actualizacion, version:version, modificadopor:modificadopor
        };
        // console.log(datosaEnviar);
        fetch(API +"?insertar=1", {
            method:"POST",
            body: JSON.stringify(datosaEnviar)
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.error && datos.error!==""){
                // console.error(datos.error);
                this.setState({serverror:datos.error});
            } else {
                // console.log(datos.id);
                this.props.history.push("/perfil2/"+datos.claveAPI);
            }
        })
        .catch(console.log)
    }

    
    render() { 

        const { docId2photo,
            docId, tipodoc, genero, 
            nombres, apellidos, 
            fechanacimiento, edad,
            email, celular, 
            fechaingreso, antiguedad, tipovinculacion,
            area, cargo, rangosalarial,
            tienefmliaclub, 
            activo, estado, 
            foto, claveAPI,
            // passwd,  comentarios, 
            // actualizacion, version, modificadopor,
            serverror
        } = this.state;
        return ( 
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>PERFIL EMPLEADO</strong></div>
                        <div>1 de 5</div>
                    </div>
                </div>
                <div className="card-body">
                    <form onSubmit={this.enviarDatos}>
                        {(docId2photo!=="")
                         ? <UploadImage foto={foto} claveAPI={claveAPI} docId={(docId)?docId:docId2photo}></UploadImage>
                         : <></>
                        }
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Tipo</strong></label>
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {tipodoc}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoDocs.tipo.map(e => {
                                            return (
                                                // <a key={e.id} className="dropdown-item" href="#">{e.name}</a>
                                                <button onClick={this.cambioValor} key={e.id} name="tipodoc" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Número Documento</strong></label>
                                <input type="text" name="docId" value={docId} onChange={this.cambioValor} id="docId"
                                    className={((this.verificarError("error_docId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Género</strong></label>
                                {/* <input type="text" id="genero" name="genero" value={genero} onChange={this.cambioValor} size="8"
                                    className={((this.verificarError("error_genero")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small> */}
                                <div className="dropdown dropleft">
                                    <button className="btn btn-info" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {genero}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoGeneros.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="genero" value={e.value} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                            <label htmlFor=""><strong>Nombres</strong></label>
                            <input type="text" name="nombres" value={nombres} onChange={this.cambioValor} id="nombres" 
                            className={((this.verificarError("error_nombres")) ? "is-invalid" :"")+" form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite los nombres con espacio y utilizando las tildes si lo requieren.</small>
                            </div>
                            <div className="form-group">
                            <label htmlFor=""><strong>Apellidos</strong></label>
                            <input type="text" id="apellidos" name="apellidos" value={apellidos} onChange={this.cambioValor}
                            className={((this.verificarError("error_apellidos")) ? "is-invalid" :"")+" form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite el apellido sin espacio y utilizando las tildes si lo requieren.</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Correo electrónico</strong></label>
                                <input type="email" id="email" name="email" value={email} onChange={this.cambioValor}
                                    className={((this.verificarError("error_email")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div><div className="form-group">
                                <label htmlFor=""><strong>Número de Celular</strong></label>
                                <input type="text" id="celular" name="celular" value={celular} onChange={this.cambioValor}
                                    className={((this.verificarError("error_celular")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite el número de celular sin espacios o guiones, solo dígite números</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Fecha de Nacimiento</strong></label>
                                <input type="date" id="fechanacimiento" name="fechanacimiento" value={fechanacimiento} onChange={this.cambioValor}
                                    className={((this.verificarError("error_fechanacimiento")) ? "is-invalid" : "") + " form-control form-control-inline"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Fecha Ingreso al Club</strong></label>
                                <input type="date" id="fechaingreso" name="fechaingreso" value={fechaingreso} onChange={this.cambioValor}
                                    className={((this.verificarError("error_fechaingreso")) ? "is-invalid" : "") + " form-control form-control-inline"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor="">Edad</label>
                                <input readOnly type="number" id="edad" name="edad" value={edad ? edad : 0} onChange={this.cambioValor}
                                    className={((this.verificarError("error_edad")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Antigüedad</label>
                                <input readOnly type="number" id="antiguedad" name="antiguedad" value={antiguedad ? antiguedad : 0} onChange={this.cambioValor}
                                    className={((this.verificarError("error_antiguedad")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Tipo de Vinculación</strong></label>
                                {/* <input type="text" id="tipovinculacion" name="tipovinculacion" value={tipovinculacion} onChange={this.cambioValor}
                                    className={((this.verificarError("error_tipovinculacion")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small> */}
                                <div className={((this.verificarError("error_tipovinculacion")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {tipovinculacion}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoVinculacion.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="tipovinculacion" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Área de Trabajo</strong></label>
                                {/* <input type="text" id="area" name="area" value={area} onChange={this.cambioValor}
                                    className={((this.verificarError("error_area")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small> */}
                                <div className={((this.verificarError("error_area")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {area}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                        {tipoAreas.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="area" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Cargo</strong></label>
                                {/* <input type="text" id="cargo" name="cargo" value={cargo} onChange={this.cambioValor}
                                    className={((this.verificarError("error_cargo")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small> */}
                                <div className={((this.verificarError("error_cargo")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                        {cargo}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                        {tipoCargos.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="cargo" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Familiar en el club?</strong></label>
                                {/* <input type="text" id="tienefmliaclub" name="tienefmliaclub" value={tienefmliaclub} onChange={this.cambioValor}
                                    className={((this.verificarError("error_tienefmliaclub")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small> */}
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-size"
                                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {tienefmliaclub}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="tienefmliaclub" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="tienefmliaclub" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor=""><strong>Asignación Salarial</strong></label>
                            <div className={((this.verificarError("error_rangosalarial")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                    {rangosalarial}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    {rangoSalarial.tipo.map(e => {
                                        return (
                                            <button onClick={this.cambioValor} key={e.id} name="rangosalarial" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                        )
                                    })}
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        
                        <div className="form-group-inline oculto">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Activo</strong></label>
                                <input readOnly type="text" id="activo" name="activo" value={activo} onChange={this.cambioValor}
                                    className={((this.verificarError("error_activo")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Estado</strong></label>
                                <input readOnly type="text" id="estado" name="estado" value={estado} onChange={this.cambioValor}
                                    className={((this.verificarError("error_estado")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="server-error">{serverror}</div>

                        <hr width="90%"/>
                        <div className="btn-group btn-acciones-1" aria-label="">
                            <button type="submit" className="btn btn-success">Siguiente</button>
                            {/* <Link to={"/"} className="btn btn-primary">Cancelar</Link> */}
                        </div>
                        
                    </form>
                </div>
                {/* <div className="card-footer text-muted">
                    
                </div> */}
            </div>
         );
    }
}

export default Perfil;